import { database } from '../index';
import { SALE_ORDER_SCHEMA, SALE_ORDER_LINE_SCHEMA, STOCK_SCHEMA } from '../schema';
import { Q } from '@nozbe/watermelondb';

const saleOrderLine = database.collections.get(SALE_ORDER_LINE_SCHEMA);


export const getSaleOrderLineByID = async (id) => await saleOrderLine.find(id)

export const getSaleOrderLineBySaleOrderID = async (id) => await saleOrderLine.query(Q.on(SALE_ORDER_SCHEMA, "id", id)).fetch()

export const getSaleOrderLineByStockID = async (id) => await saleOrderLine.query(Q.on(STOCK_SCHEMA, 'id', id)).fetch();



export const ObserveSaleOrderLineBySaleOrder = (id) =>
    saleOrderLine.query(Q.on(SALE_ORDER_SCHEMA, "id", id)).observeWithColumns(['discount', 'selling_price', 'quantity']);

export const deleteSaleOrderLineById = async (id) => {
    await database.write(async () => {
        const saleOrderLine = await getSaleOrderLineByID(id)
        await saleOrderLine.destroyPermanently();
    });
}

export const updateSaleOrderLine = async ({ name, quantity, selling_price, discount, id, discount_method }) => {
    await database.write(async () => {
        const existingSaleOrderLine = await getSaleOrderLineByID(id);
        await existingSaleOrderLine.update((c) => {
            c.name = name;
            c.quantity = quantity;
            c.selling_price = selling_price;
            c.discount = discount ?? c.discount;
            c.discount_method = discount_method ?? c.discount_method;

        });
    });
}

const prepareDeletion = async (saleOrderLines) => {
    return await Promise.all(
        saleOrderLines.map(async (SOL) => {
            try {
                return SOL.prepareDestroyPermanently();
            } catch (err) {
            }
        })
    );
};
export const deleteAllSaleOrderLineById = async (id) => {
    await database.write(async () => {
        const saleOrderLines = await getSaleOrderLineBySaleOrderID(id);
        const allRecords = await prepareDeletion(saleOrderLines);
        await database.batch(...allRecords)
    });
}

export const deleteSaleOrderLineByStockId = async (id) => {
    try {
        await database.write(async () => {
            const saleOrderLines = await getSaleOrderLineByStockID(id)
            const allRecords = await prepareDeletion(saleOrderLines);
            await database.batch(...allRecords)
        })
    } catch (error) {
    }
}